export const environment = {
	production: false,
	backendServerUrl: '',
};
